import { Component, Input, ViewChild, signal, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DsRowData, DsIconModule, DsBoxModule } from '@bmw-ds/components';
import { DsLinkModule, DsButtonModule } from '@bmw-ds/components';
import { ApiService } from '../../services/api.service';
import { ExportService } from '../../services/export.service';
import { DsTagModule } from '@bmw-ds/components';
import { ViewDataRendererComponent } from '../../shared/view-data-renderer/view-data-renderer';
import {
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
} from '@bmw-ds/components';
import { AgGridModule } from 'ag-grid-angular';
import {
  GridApi,
  GridReadyEvent,
  ColDef,
  GridOptions,
  ModuleRegistry,
  AllCommunityModule,
  Theme,
} from 'ag-grid-community';
import { ICDQuartzTheme } from '../../shared/ag-theme';
import { StopSaleCellRenderer } from 'src/app/shared/stopSaleCellRenderer/stop-sale-cell-renderer/stop-sale-cell-renderer';
import { CommonService } from 'src/app/services/common.service';
import { hyperlinkWindowCellRenderer } from 'src/app/shared/hyperlinkWindowCellRenderer/hyperlink-window-cell-rendere';
import { ApiDsMessageComponent } from 'src/app/shared/apiDsMessage/apiDsMessage';
ModuleRegistry.registerModules([AllCommunityModule]);
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-inventory-campaign-details-table',
  standalone: true,
  imports: [
    CommonModule,
    AgGridModule,
    DsLinkModule,
    DsIconModule,
    DsBoxModule,
    DsButtonModule,
    DsTagModule,
  ],
  providers: [ApiService],
  templateUrl: './inventory-campaign-details-table.html',
  styleUrls: ['./inventory-campaign-details-table.scss'],
})
export class InventoryCampaignDetailsTable implements OnInit {
  totalVechileCountSum: number = 0;
  scrollHeight: string = '200px';
  readonly maxVisibleRows = 8;
  readonly rowHeight = 40;
  readonly headerHeight = 50;
  readonly floatingFiltersHeight = 40;
  readonly paginationPanelHeight = 48;
  disclaimer: any;
  // Centralized GridOptions config; set domLayout here
  gridOptions: GridOptions = {
    domLayout: 'normal', // options: 'normal' | 'autoHeight' | 'print'
  };
  fileDownloadTableData: any;
  dealerDesc: any;
  dealerCode: any;
  constructor(
    private apiService: ApiService,
    private commonService: CommonService,
    private router: Router,
    private loadingAreaService: DsLoadingAreaService,
    private exportService: ExportService
  ) {}
  private isRedColor = (params: any) =>
    String(params?.data?.Color ?? '')
      .trim()
      .toLowerCase() === 'red';
  theme: Theme | 'legacy' = ICDQuartzTheme;
  paginationPageSize: number = 10;
  paginationPageSizeSelector: number[] | boolean = [10, 20, 30];
  noRowsTemplate =
    '<div class="icd-no-rows" role="status" aria-live="polite">No Rows Found</div>';
  rowData: DsRowData[] = [];
  pinnedBottomRowData: any[] = [];
  displayedPinnedBottomRowData: any[] = [];
  pinnedTopRowData: any[] = [];
  fileDownloadPayload: any;
  apiSeachDynamicData: any;
  currentDate: string = '';
  currentTime: string = '';
  loadingAreaConfig: DsLoadingAreaConfiguration = {
    id: 'bodyLoading',
    loadingTitle: 'Details are being displayed, this may take few seconds..',
    loadingText:
      'Please do not close the browser window. wait while we load data.',
  };
  isBackButtonPresent: any;
  downloadResponse: any;
  loadingKey = signal<string | null>(null);
  selectedCriteria: any;
  private gridApi?: GridApi;
  @ViewChild(ApiDsMessageComponent) apiErrorMsg!: ApiDsMessageComponent;

  // ← boolean: true if ANY of the 4 floating filters is active
  isFloatingFilterActive: boolean = false;

  // ← stores active filter column and its value
  activeFilterValues: { colId: string; value: string }[] = [];

  // ← the 4 columns that have floating filters
  private readonly floatingFilterCols = [
    'DefectCode',
    'DefectDescription',
    'BulletinNumber',
    'RecallNumber',
  ];
  private filterDebounceTimer: any = null;
  private buildPinnedBottomRowData(): any[] {
    if (this.rowData.length === 0) {
      return [];
    }

    return [
      {
        StopSale: null,
        DefectCode: '',
        DefectDescription: '',
        BulletinNumber: '',
        RecallNumber: '',
        CampaignStartDate: 'Total Vehicle Count:',
        DealerInventory:
          this.apiSeachDynamicData?.campaignInventoryModel?.dealerInvCnt ??
          this.apiSeachDynamicData?.dealerInventoryTotalVehicleCount,
        DemoLoaner:
          this.apiSeachDynamicData?.campaignInventoryModel?.demoLnrCnt ??
          this.apiSeachDynamicData?.demoLoanerTotalVehicleCount,
        PreOwned:
          this.apiSeachDynamicData?.campaignInventoryModel?.preOwnedCnt ??
          this.apiSeachDynamicData?.preOwnedTotalVehicleCount,
        TotalVehicleCount:
          this.apiSeachDynamicData?.campaignInventoryModel?.totalVINCnt ??
          this.apiSeachDynamicData?.totalVehicleCount,
      },
    ];
  }

  private updateTableHeight(rowCount: number): void {
    const visibleRows = Math.min(Math.max(rowCount, 1), this.maxVisibleRows);
    const pinnedRows = this.displayedPinnedBottomRowData.length;
    const totalRows = visibleRows + pinnedRows;
    const chromeHeight =
      this.headerHeight +
      this.floatingFiltersHeight +
      this.paginationPanelHeight;
    this.scrollHeight = `${chromeHeight + totalRows * this.rowHeight + 8}px`;
    // console.log('table height:', this.scrollHeight);
  }

  private updateTableHeightForPagination(visibleRowCount: number): void {
    const cappedRows = Math.min(
      Math.max(visibleRowCount, 1),
      this.maxVisibleRows
    );
    const pinnedRows = this.displayedPinnedBottomRowData.length;
    const totalRows = cappedRows + pinnedRows;
    const chromeHeight =
      this.headerHeight +
      this.floatingFiltersHeight +
      this.paginationPanelHeight;
    this.scrollHeight = `${chromeHeight + totalRows * this.rowHeight + 8}px`;
    // console.log('table height (pagination):', this.scrollHeight);
  }

  private syncEmptyStateToGrid(displayedRowCount: number): void {
    const hasDisplayedRows = displayedRowCount > 0;

    this.displayedPinnedBottomRowData = hasDisplayedRows
      ? this.pinnedBottomRowData
      : [];

    if (!this.gridApi) {
      return;
    }

    if (hasDisplayedRows) {
      this.gridApi.hideOverlay?.();
      return;
    }
    if (this.isFloatingFilterActive) {
      this.noRowsTemplate = `
        <div class="icd-no-rows" role="status" aria-live="polite">
          <span>No matching rows found for the applied filter(s).</span>
          <br/>
          <span style="font-size:12px; color:#888;">Try adjusting or clearing the column filter.</span>
        </div>`;
    } else {
      this.noRowsTemplate = `<div class="icd-no-rows" role="status" aria-live="polite">No Rows Found</div>`;
    }

    this.gridApi.showNoRowsOverlay?.();
  }

  private syncTableHeightToGridState(): void {
    if (!this.gridApi) {
      this.updateTableHeight(this.rowData.length);
      return;
    }

    const displayedRowCount = this.gridApi.getDisplayedRowCount();
    this.syncEmptyStateToGrid(displayedRowCount);
    const currentPage = this.gridApi.paginationGetCurrentPage();
    const pageSize = this.gridApi.paginationGetPageSize();
    const startIndex = currentPage * pageSize;
    const visibleRowsOnCurrentPage = Math.max(
      Math.min(displayedRowCount - startIndex, pageSize),
      0
    );

    this.updateTableHeightForPagination(visibleRowsOnCurrentPage);
  }

  ngOnInit(): void {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.getTableData();
    this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id); // Removes the loading area
    // Initialize from service properties
    this.currentDate = this.commonService.currentDate as string;
    this.currentTime = (this.commonService.currentTime + ' EST') as string;

    // Subscribe to criteria changes from the form
    this.commonService.selectedCriteria.subscribe((criteria) => {
      this.selectedCriteria = criteria;
      // console.log('Received criteria in table component:', criteria);
    });
    this.commonService.dealerCode.subscribe((code) => {
      this.dealerCode = code;
    });
    this.commonService.dealerDesc.subscribe((desc) => {
      this.dealerDesc = desc;
    });
    this.commonService.isBackButtonPresent.subscribe((isPresent) => {
      this.isBackButtonPresent = isPresent;
    });
    this.commonService.isClearSelectionClicked.subscribe((isClear: boolean) => {
      if (isClear && this.gridApi) {
        this.gridApi.setFilterModel(null); // clears all floating filters
        this.gridApi.onFilterChanged(); // refreshes the grid
        console.log('All filters cleared due to isClearSelectionClicked');
        this.commonService.isFloatingFilterActive.next(false); // Reset floating filter state when coming back from Market screen
        this.commonService.agGridFilters.next([]); // Clear any existing column filters when coming back from Market screen
        // ? Reset the flag back to false after clearing
        this.commonService.isClearSelectionClicked.next(false);
      }
    });
  }
  onGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.syncTableHeightToGridState();
  }

  onPaginationChanged(): void {
    if (!this.gridApi) {
      return;
    }

    this.paginationPageSize = this.gridApi.paginationGetPageSize();
    this.syncTableHeightToGridState();
  }

  onFilterChanged(): void {
    this.syncTableHeightToGridState();
    //clearing previous timer if user is still typing/changing filters within debounce period
    if (this.filterDebounceTimer) {
      clearTimeout(this.filterDebounceTimer);
      this.filterDebounceTimer = null;
    }
    // ← wait 600ms after last keystroke THEN track active filters and push to service
    this.filterDebounceTimer = setTimeout(() => {
      this.filterDebounceTimer = null;
      this.trackActiveFloatingFilters();
    }, 600);
  }

  // ← tracks which of the 4 floating filters are active and their values
  private trackActiveFloatingFilters(): void {
    if (!this.gridApi) return;

    const filterModel = this.gridApi.getFilterModel();

    // ← collect active filters only from the 4 floating filter columns
    this.activeFilterValues = this.floatingFilterCols
      .filter((colId: string) => !!filterModel[colId]?.filter)
      .map((colId: string) => ({
        colId,
        value: String(filterModel[colId]?.filter ?? ''),
      }));

    const isActive = this.activeFilterValues.length > 0;
    // ← detect when LAST filter was just cleared
    const wasActive = this.isFloatingFilterActive;
    this.isFloatingFilterActive = isActive;
    if (wasActive && !isActive) {
      // console.log('Last filter cleared — isActive changed true → false');
      // ← push false immediately — no need to wait
      this.isFloatingFilterActive = false;
      this.commonService.isFloatingFilterActive.next(false);
      this.commonService.agGridFilters.next([]);
      return; // ← exit early — no need to process further
    }
    // ← push isFloatingFilterActive FIRST (just boolean — no API call triggered)
    this.commonService.isFloatingFilterActive.next(isActive);

    // ← push agGridFilters SECOND — form subscription triggers API call here
    // by this point activeFilterValues in form is already updated
    this.commonService.agGridFilters.next(this.activeFilterValues);

    this.isFloatingFilterActive = isActive;
    this.activeFilterValues = this.activeFilterValues;

    // console.log('isFloatingFilterActive:', isActive);
    // console.log('agGridFilters:', this.activeFilterValues);
  }

  getTableData() {
    this.commonService.icdResponseData.subscribe({
      next: (data: any) => {
        if (data) {
          // console.log('ICD Table Data Response:', data);
          const root = data ?? {};
          this.apiSeachDynamicData = data;
          const list = root?.inventoryCampaignDetailsList ?? root;
          const defectModels =
            (list?.campaignInventoryModel?.campaignInventoryDefectModel ||
              data?.selectedFiltersDefectCodesData) ??
            [];
          this.updateTableHeight(defectModels.length);
          // console.log('Scroll height set to:', this.scrollHeight);
          this.disclaimer =
            (environment.isB2E
              ? root?.campaignInventoryModel?.idisclaimer
              : root?.campaignInventoryModel?.ddisclaimer) ??
            (environment.isB2E
              ? root?.internalDisclaimer
              : root?.dealerDisclaimer);
          //   (this.isBackButtonPresent ? root?.campaignInventoryModel?.ddisclaimer: root?.campaignInventoryModel?.idisclaimer) ??(this.isBackButtonPresent? root?.dealerDisclaimer:root?.internalDisclaimer);
          this.rowData = (defectModels || []).map((row: any) => ({
            StopSale: row['stopSaleFlg'] ?? row['StopSale'] ?? null,
            DefectCode: row['defectCode'] ?? row['DefectCode'] ?? null,
            DefectDescription: this.commonService.cleanMojibake(
              row['defectDesc'] ?? row['DefectDescription'] ?? null
            ),
            BulletinNumber: row['bulletin'] ?? row['bulletinNber'] ?? null,
            RecallNumber: row['campaignNo'] ?? row['recallNber'] ?? null,
            CampaignStartDate:
              row['campaignStartDate'] ?? row['CampaignStartDate'] ?? null,
            DealerInventory:
              row['dealerInventoryCount'] ?? row['DealerInventor'] ?? null,
            DemoLoaner: row['demoLoanerCount'] ?? row['DemoLoaner'] ?? null,
            PreOwned: row['preOwnedCount'] ?? row['PreOwned'] ?? null,
            TotalVehicleCount: row['total'] ?? row['totalVehicleCount'] ?? null,
            Color:
              row['stopSaleFlg'] === true ||
              String(row['stopSaleFlg']).trim().toLowerCase() === 'y' ||
              String(row['stopSaleFlg']).trim().toLowerCase() === 'yes' ||
              String(row['stopSaleFlg']).trim().toLowerCase() === 'true'
                ? 'red'
                : '',
            BulletinUrl: environment.isB2E
              ? (row['tisURLinternal'] ?? row['bulletinUrlInternal'] ?? null)
              : (row['tisURLDealer'] ?? row['bulletinUrlDealer'] ?? null),
          }));
          // console.log('Processed row data for table:', this.rowData);
          this.pinnedBottomRowData = this.buildPinnedBottomRowData();
          this.displayedPinnedBottomRowData =
            this.rowData.length > 0 ? this.pinnedBottomRowData : [];
          this.totalVechileCountSum =
            this.pinnedBottomRowData[0]?.TotalVehicleCount ?? 0;
          this.pinnedTopRowData = [{}];
          this.updateTableHeight(this.rowData.length);
          this.commonService.disclaimer.next(this.disclaimer);
        }
      },
      error: (error: any) => {
        console.log('Error in fetching error search data', error);
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id); // Removes the loading area
      },
      complete: () => {
        console.log('ICD Table Data fetch completed');
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id); // Removes the loading area
      },
    });
  }

  goBack() {
    this.router.navigate(['campaign_inventory_internal_market'], {
      queryParams: {
        column: 'market',
        value: this.commonService.regionalScreenSelectedValue.getValue(),
      },
    });
  }

  onDataViewClick(params: any) {
    const isPinnedBottom =
      params?.node?.rowPinned === 'bottom' ||
      params?.rowPinned === 'bottom' ||
      params?.node?.floating === 'bottom';
    const columnName =
      params?.colDef?.field ?? params?.column?.getColId?.() ?? '';
    const value = params?.value ?? params?.data?.[columnName] ?? '';
    if (isPinnedBottom) {
      console.log('Pinned bottom row clicked', { column: columnName, value });
    }
    this.router.navigate(['vcd'], {
      queryParams: {
        column: columnName,
        value: value,
        defectCode: isPinnedBottom ? 'ALL' : (params.data?.DefectCode ?? null),
      },
    });
  }

  onBulletinClick(params: any) {
    const url = String(
      params?.data?.BulletinUrl ?? params?.data?.BulletinUrl ?? ''
    ).trim();
    if (!url) {
      console.warn('No bulletinUrl available for row:', params?.data);
      return;
    }
    window.open(url, '_blank');
  }

  columns: ColDef[] = [
    {
      field: 'StopSale',
      headerName: 'Stop Sale',
      maxWidth: 100,
      cellRendererSelector: (params: any) => {
        // Do not render icon for pinned rows
        if (params?.node?.rowPinned) return undefined;
        return { component: StopSaleCellRenderer };
      },

      //need to add the icon here
    },
    {
      field: 'DefectCode',
      headerName: 'Defect Code',
      floatingFilter: true,
      maxWidth: 150,
      filter: true,
      cellClassRules: { 'color-red': (params) => this.isRedColor(params) },
    },
    {
      field: 'DefectDescription',
      headerName: 'Defect Description',
      floatingFilter: true,
      filter: true,
      flex: 1,
      cellClassRules: { 'color-red': (params) => this.isRedColor(params) },
    },
    {
      field: 'BulletinNumber',
      headerName: 'Bulletin Number',
      floatingFilter: true,
      maxWidth: 130,
      filter: true,
      autoHeight: true,
      cellRendererSelector: (params: any) => {
        // Do not render hyperlink for pinned rows (totals row)
        if (params?.node?.rowPinned) return undefined;
        // Do not render hyperlink for empty values
        if (!params?.value && params?.value !== 0) return undefined;
        return {
          component: hyperlinkWindowCellRenderer,
          params: {
            onClick: this.onBulletinClick.bind(this),
          },
        };
      },
      cellClassRules: { 'color-red': (params) => this.isRedColor(params) },
    },
    {
      field: 'RecallNumber',
      headerName: 'Recall Number',
      tooltipField: 'recallNumber',
      maxWidth: 130,
      filter: true,
      floatingFilter: true,
      // wrapText:true,
      autoHeight: true,
      cellClassRules: { 'color-red': (params) => this.isRedColor(params) },
    },
    {
      field: 'CampaignStartDate',
      headerName: 'Campaign Start Date',
      maxWidth: 180,
      autoHeight: true,
      flex: 1,
      cellClassRules: { 'color-red': (params) => this.isRedColor(params) },
    },
    {
      field: 'DealerInventory',
      headerName: 'Dealer Inventory',
      maxWidth: 150,
      tooltipField: 'refId',
      // wrapText:true,
      autoHeight: true,
      sortable: true,
      flex: 1,
      cellRenderer: ViewDataRendererComponent,
      cellRendererParams: {
        onClick: this.onDataViewClick.bind(this),
      },
    },
    {
      field: 'DemoLoaner',
      headerName: 'Demo/Loaner',
      maxWidth: 130,
      autoHeight: true,
      // wrapText: true,
      sortable: true,
      flex: 1,
      // cellRenderer: this.linkRenderer('DemoLoaner'),
      cellRenderer: ViewDataRendererComponent,
      cellRendererParams: {
        onClick: this.onDataViewClick.bind(this),
      },
    },
    {
      field: 'PreOwned',
      headerName: 'Pre-Owned',
      maxWidth: 130,
      tooltipField: 'eventType',
      autoHeight: true,
      sortable: true,
      flex: 1,
      cellRenderer: ViewDataRendererComponent,
      cellRendererParams: {
        onClick: this.onDataViewClick.bind(this),
      },
    },
    {
      field: 'TotalVehicleCount',
      headerName: 'Total Vehicle Count',
      maxWidth: 150,
      sortable: true,
      flex: 1,
      cellRenderer: ViewDataRendererComponent,
      cellRendererParams: {
        onClick: this.onDataViewClick.bind(this),
      },
    },
  ];

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    wrapHeaderText: true,
    filterParams: {
      closeOnApply: true,
      suppressAndOrCondition: true,
      maxNumConditions: 1,
      trimInput: false,
      filterOptions: [
        // ? explicitly list all filter options you want
        'contains',
      ],
      defaultOption: 'contains',
    },
  };

  downloadApiImplementation(format: 'pdf' | 'csv', scope: 'export' | 'total') {
    // console.log("apiSeachDynamicData:", this.apiSeachDynamicData);
    this.loadingKey.set(`${format}-${scope}`);
    this.fileDownloadPayload = {
      centerID:
        this.apiSeachDynamicData?.campaignInventoryModel?.centerCode ||
        this.dealerCode ||
        '',
      inventoryCampaignDetails:
        'Dealer ' + this.dealerCode + ' - ' + this.dealerDesc,
      lineMakesSelected: this.selectedCriteria['Line Make'] || 'ALL',
      campaignTypesSelected: this.selectedCriteria['Campaign Type'] || 'ALL',
      enggSeriesSelected: this.selectedCriteria['Engineering Series'] || 'ALL',
      modelYearsSelected: this.selectedCriteria['Model Year'] || 'ALL',
      locationsSelected: this.selectedCriteria['Location'] || 'ALL',
      selectedVehicleCampaignStaus:
        this.selectedCriteria['Vehicle Campaign Status'],
      selectedDemoLnrOption:
        this.selectedCriteria['Demo / Loaner Vehicle Count'],
      mainInventory: 'ALL',
      defectCd: 'ALL',
      disclaimer: this.disclaimer || '',
      exportToPDF: format === 'pdf' && scope === 'export' ? true : false,
      exportToCSV: format === 'csv' && scope === 'export' ? true : false,
      totalDealerVINExportToPDF:
        format === 'pdf' && scope === 'total' ? true : false,
      totalDealerVINExportToCSV:
        format === 'csv' && scope === 'total' ? true : false,
      coloumnFilter: this.isFloatingFilterActive,
      defectCodeFilter: this.activeFilterValues.find(
        (f) => f.colId === 'DefectCode'
      )?.value
        ? true
        : false,
      defectDescFilter: this.activeFilterValues.find(
        (f) => f.colId === 'DefectDescription'
      )?.value
        ? true
        : false,
      bulletinNumberFilter: this.activeFilterValues.find(
        (f) => f.colId === 'BulletinNumber'
      )?.value
        ? true
        : false,
      recallNumberFilter: this.activeFilterValues.find(
        (f) => f.colId === 'RecallNumber'
      )?.value
        ? true
        : false,
      defectCodeSelected:
        this.activeFilterValues.find((f) => f.colId === 'DefectCode')?.value ||
        '',
      defectDescSelected:
        this.activeFilterValues.find((f) => f.colId === 'DefectDescription')
          ?.value || '',
      bulletinNumberSelected:
        this.activeFilterValues.find((f) => f.colId === 'BulletinNumber')
          ?.value || '',
      recallNumberSelected:
        this.activeFilterValues.find((f) => f.colId === 'RecallNumber')
          ?.value || '',
    };

    // console.log('File Download Payload:', this.fileDownloadPayload);

    this.apiService.getDownloadFiles(this.fileDownloadPayload).subscribe({
      next: (data: any) => {
        this.downloadResponse = data;
      },
      error: (error: any) => {
        this.loadingKey.set(null);
        console.log('Error in fetching download files', error);
        this.apiErrorMsg?.showError(
          'caught an error in downloading the files.Please try again...',
          'critical'
        );
      },
      complete: () => {
        (async () => {
          try {
            if (format === 'pdf' && scope === 'export') {
              await this.pdfDownload(this.downloadResponse, 'export');
            } else if (format === 'pdf' && scope === 'total') {
              await this.pdfDownload(this.downloadResponse, 'total');
            } else if (format === 'csv' && scope === 'export') {
              this.excelDownload(this.downloadResponse, 'export');
            } else if (format === 'csv' && scope === 'total') {
              this.excelDownload(this.downloadResponse, 'total');
            }
            this.apiErrorMsg?.showError(
              'Successfully Downloaded the requested files',
              'positive'
            );
            console.log('Download files request completed');
          } catch (err) {
            console.error('Error generating download file:', err);
            this.apiErrorMsg?.showError(
              'caught an error in downloading the files.Please try again...',
              'critical'
            );
          } finally {
            this.loadingKey.set(null);
          }
        })();
      },
    });
  }
  private formatColLabel(colId: string): string {
    return colId
      .replace(/([A-Z])/g, ' $1') // ← add space before each capital letter
      .trim(); // ← remove leading space
  }
  pdfDownload(downloadResponse?: any, scope?: 'export' | 'total') {
    const heading = downloadResponse?.inventoryCampaignDetails ?? '';
    const toDetails = (obj: Record<string, any> | undefined) => {
      const entries = Object.entries(obj ?? {});
      return entries.map(([label, value]) => ({ label, value }));
    };
    const baseDetails = toDetails(this.selectedCriteria).concat([
      {
        label: 'Details as of',
        value: this.currentDate + ' at ' + this.currentTime,
      },
    ]);
    const filterDetails = this.isFloatingFilterActive
      ? this.activeFilterValues.map((f) => ({
          label: `${this.formatColLabel(f.colId)} contains:`,
          value: f.value,
        }))
      : [];
    const details = [...baseDetails, ...filterDetails];
    const centerCode =
      this.apiSeachDynamicData?.campaignInventoryModel?.dealerModel?.dealer +
      '-' +
      this.apiSeachDynamicData?.campaignInventoryModel?.dealerModel?.grpDesc;
    const dealerTitle = `${heading || (this.dealerCode ? `${this.dealerCode} - ${this.dealerDesc}` : centerCode || '')}`;
    let cols: string[];
    let headers: string[];
    let columnWidthsPt: number[] | undefined;

    // Build rows and set columns/headers based on scope
    if (scope === 'export') {
      // Use grid columns for export scope
      cols = this.columns.map((c) => c.field as string).filter(Boolean);
      headers = this.columns
        .map((c) => (c.headerName || c.field) as string)
        .filter(Boolean);

      // Derive current column widths from AG Grid and convert px -> pt
      try {
        if (this.gridApi) {
          const state = this.gridApi.getColumnState();
          const widthById = new Map<string, number>(
            state.map((s) => [s.colId, s.width ?? 100])
          );
          columnWidthsPt = cols.map((id) => (widthById.get(id) ?? 100) * 0.75);
        }
      } catch {}

      this.fileDownloadTableData = (
        downloadResponse?.campaignInventoryExportModel || []
      ).map((row: any) => ({
        StopSale: row['stopSaleFlg'] ?? row['StopSale'] ?? null,
        DefectCode: row['defectCode'] ?? row['DefectCode'] ?? null,
        DefectDescription: this.commonService.cleanMojibake(
          row['defectDesc'] ?? row['DefectDescription'] ?? null
        ),
        BulletinNumber: row['bulletinNber'] ?? row['BulletinNumber'] ?? null,
        RecallNumber: row['campaignNo'] ?? row['recallNber'] ?? null,
        CampaignStartDate:
          row['campaignStartDate'] ?? row['CampaignStartDate'] ?? null,
        DealerInventory:
          row['dealerInventoryCount'] ?? row['DealerInventor'] ?? null,
        DemoLoaner: row['demoLoanerCount'] ?? row['DemoLoaner'] ?? null,
        PreOwned: row['preOwnedCount'] ?? row['PreOwned'] ?? null,
        TotalVehicleCount:
          row['totalVehicleCount'] ?? row['TotalVehicleCount'] ?? null,
        ICDColor:
          row['stopSaleFlg'] === true ||
          String(row['stopSaleFlg']).trim().toLowerCase() === 'y' ||
          String(row['stopSaleFlg']).trim().toLowerCase() === 'yes' ||
          String(row['stopSaleFlg']).trim().toLowerCase() === 'true'
            ? 'red'
            : '',
      }));
      const totalsRow = {
        StopSale: null,
        DefectCode: '',
        DefectDescription: '',
        BulletinNumber: null,
        RecallNumber: '',
        CampaignStartDate: 'Total Vehicle Count:',
        DealerInventory:
          downloadResponse?.dealerInventoryTotalVehicleCount ?? null,
        DemoLoaner: downloadResponse?.demoLoanerTotalVehicleCount ?? null,
        PreOwned: downloadResponse?.preOwnedTotalVehicleCount ?? null,
        TotalVehicleCount: downloadResponse?.totalVehicleCount ?? null,
        isTotalsRow: true,
      } as any;
      this.fileDownloadTableData.push(totalsRow);
      this.exportService.exportPdfWithDetails(
        'ICD_Export',
        this.fileDownloadTableData,
        cols,
        headers,
        details,
        {
          title: 'Inventory Campaign Details',
          dealerTitle: dealerTitle,
          disclaimer: this.disclaimer,
          printedOn: this.currentDate + ' at ' + this.currentTime,
          orientation: 'landscape',
          rowHeight: 40,
          cellPadding: 8,
          headerFillColor: '#e0e0e0',
          headerTextColor: '#0e0e0e',
          textColor: '#1a1a1a',
          zebraFillColor: '#f5f5f5',
          columnWidths: columnWidthsPt,
          renderIcons: true,
          // pinnedBottomFillColor: '#e3f2fd',
        }
      );
    } else if (scope === 'total') {
      // Use full columns for total scope
      cols = [
        'StopSale',
        'OverallRemedyAvailable',
        'VIN',
        'Inventory',
        'SubInventory',
        'PriorityCode',
        'LineMakeDescription',
        'EngineeringSeries',
        'NAModelCodeDescription',
        'ModelYear',
        'RemedyStatusAllOpenCampaigns',
      ];
      headers = [
        'Stop Sale',
        'Overall Remedy Available(ORA)',
        'VIN',
        'Inventory',
        'Sub Inventory',
        'Priority Code',
        'Line Make Description',
        'Engineering Series',
        'NA Model Code-Description',
        'Model Year',
        'Remedy Status',
      ];
      // Keep Remedy Status wide enough to avoid excessive wrapping/overlap in PDF.
      columnWidthsPt = [42, 50, 94, 58, 58, 50, 86, 76, 108, 50, 178];

      this.fileDownloadTableData = (
        downloadResponse?.campaignInventoryExportModel ?? []
      ).map((row: any) => {
        return {
          StopSale: row['stopSaleFlg'] ?? row['StopSale'] ?? null,
          OverallRemedyAvailable: row['overallRemedyAvl'] ?? null,
          VIN: row['vin'] ?? null,
          Inventory: row['inventory'] ?? null,
          SubInventory: row['subInventory'] ?? null,
          PriorityCode: row['priorityCode'] ?? null,
          LineMakeDescription: row['lineMakeDescription'] ?? null,
          EngineeringSeries: row['engineSeries'] ?? null,
          NAModelCodeDescription: row['naModelCodeDesc'] ?? null,
          ModelYear: row['modelYear'] ?? null,
          // Keep raw remedy payload so PDF renderer can place icons and row-level colors correctly.
          RemedyStatusAllOpenCampaigns:
            this.formatRemedyForPdf(row?.remedyStatusAllOpenCampaigns) ?? null,
          VCDColor: this.hasRedRemedyStatus(row?.remedyStatusAllOpenCampaigns)
            ? 'red'
            : '',
        };
      });
      this.exportService.exportPdfWithDetails(
        'ICD_total',
        this.fileDownloadTableData,
        cols,
        headers,
        details,
        {
          title: 'Inventory Campaign Details',
          dealerTitle: dealerTitle,
          disclaimer: this.disclaimer,
          printedOn: this.currentDate + ' at ' + this.currentTime,
          orientation: 'landscape',
          rowHeight: 40,
          cellPadding: 8,
          headerFillColor: '#e0e0e0',
          headerTextColor: '#0e0e0e',
          textColor: '#1a1a1a',
          zebraFillColor: '#f5f5f5',
          columnWidths: columnWidthsPt,
          renderIcons: true,
          // pinnedBottomFillColor: '#e3f2fd',
        }
      );
    }
  }

  excelDownload(downloadResponse?: any, scope?: 'export' | 'total') {
    const toDetails = (obj: Record<string, any> | undefined) => {
      const entries = Object.entries(obj ?? {});
      return entries.map(([label, value]) => ({ label, value }));
    };
    const baseDetails = toDetails(this.selectedCriteria).concat([
      {
        label: 'Details as of',
        value: this.currentDate + ' at ' + this.currentTime,
      },
    ]);
    const filterDetails = this.isFloatingFilterActive
      ? this.activeFilterValues.map((f) => ({
          label: `${this.formatColLabel(f.colId)} contains:`,
          value: f.value,
        }))
      : [];
    const details = [...baseDetails, ...filterDetails];
    const centerCode = this.isBackButtonPresent
      ? this.apiSeachDynamicData?.campaignInventoryModel?.dealerModel?.dealer +
          '-' +
          this.apiSeachDynamicData?.campaignInventoryModel?.dealerModel
            ?.grpDesc ||
        this.apiSeachDynamicData?.centerId +
          '-' +
          this.apiSeachDynamicData?.dealerDesc
      : null;
    // Build rows and append a pinned-bottom style totals row for CSV

    if (scope === 'export') {
      const cols = this.columns.map((c) => c.field as string).filter(Boolean);
      const headers = this.columns
        .map((c) => (c.headerName || c.field) as string)
        .filter(Boolean);
      this.fileDownloadTableData = (
        downloadResponse?.campaignInventoryExportModel || []
      ).map((row: any) => ({
        StopSale: row['stopSaleFlg'] ?? row['StopSale'] ?? null,
        DefectCode: row['defectCode'] ?? row['DefectCode'] ?? null,
        DefectDescription: this.commonService.cleanMojibake(
          row['defectDesc'] ?? row['DefectDescription'] ?? null
        ),
        BulletinNumber:
          row['bulletin'] ??
          row['BulletinNumber'] ??
          row['bulletinNber'] ??
          null,
        RecallNumber:
          row['campaignNo'] ?? row['RecallNumber'] ?? row['recallNber'] ?? null,
        CampaignStartDate:
          row['campaignStartDate'] ?? row['CampaignStartDate'] ?? null,
        DealerInventory:
          row['dealerInventoryCount'] ?? row['DealerInventor'] ?? null,
        DemoLoaner: row['demoLoanerCount'] ?? row['DemoLoaner'] ?? null,
        PreOwned: row['preOwnedCount'] ?? row['PreOwned'] ?? null,
        TotalVehicleCount:
          row['totalVehicleCount'] ?? row['TotalVehicleCount'] ?? null,
        VCDColor: this.formatRemedyForPdf(
          row?.remedyStatusAllOpenCampaigns
        )?.includes('red')
          ? 'red'
          : '',
      }));
      const totalsRow = {
        StopSale: null,
        DefectCode: '',
        DefectDescription: '',
        BulletinNumber: null,
        RecallNumber: '',
        CampaignStartDate: 'Total Vehicle Count:',
        DealerInventory:
          downloadResponse?.dealerInventoryTotalVehicleCount ?? null,
        DemoLoaner: downloadResponse?.demoLoanerTotalVehicleCount ?? null,
        PreOwned: downloadResponse?.preOwnedTotalVehicleCount ?? null,
        TotalVehicleCount: downloadResponse?.totalVehicleCount ?? null,
      } as any;
      this.fileDownloadTableData.push(totalsRow);
      this.exportService.exportCsvWithDetails(
        'ICD_Export',
        this.fileDownloadTableData,
        centerCode ? [`Center Code: ${centerCode}`] : [],
        cols,
        headers,
        details,
        { title: '', addBom: true }
      );
    } else if (scope === 'total') {
      const fullCols = [
        'VIN',
        'Chassis',
        'StopSale',
        'OverallRemedyAvailable',
        'ORAStatusDate',
        'RemedyStatus',
        'Inventory',
        'SubInventory',
        'PriorityCode',
        'ProductionDate',
        'LineMakeDescription',
        'EngineeringSeries',
        'ModelYear',
        'NAModelCodeDescription',
        'Region',
        'Market',
        'CenterID',
        'LocationCode',
        'DefectCode',
        'DefectDescription',
        'BulletinNumber',
        'RecallNumber',
        'CampaignType',
      ];
      const fullHeaders = [
        'VIN',
        'Chassis',
        'Stop Sale',
        'Overall Remedy Available(ORA)',
        'Status Date',
        'Remedy Status',
        'Inventory',
        'Sub Inventory',
        'Priority Code',
        'Production Date',
        'Line Make Description',
        'Engineering Series',
        'Model Year',
        'NA Model Code-Description',
        'Region',
        'Market',
        'Center ID',
        'Location Code',
        'Defect Code',
        'Defect Description',
        'Bulletin Number',
        'Recall Number',
        'Campaign Type',
      ];
      this.fileDownloadTableData = (
        downloadResponse?.campaignInventoryExportModel ?? []
      ).map((row: any) => {
        const remedy = Array.isArray(row?.remedyStatusAllOpenCampaigns)
          ? row.remedyStatusAllOpenCampaigns[0]
          : row?.remedyStatusAllOpenCampaigns;
        return {
          VIN: row['vin'] ?? null,
          Chassis: row['chasis_11_17'] ?? null,
          StopSale: row['stopSaleFlg'] ?? row['StopSale'] ?? null,
          OverallRemedyAvailable: row['overallRemedyAvl'] ?? null,
          ORAStatusDate: row['oraStatusDate'] ?? null,
          RemedyStatus:
            this.formatRemedyForCsv(row?.remedyStatusAllOpenCampaigns) || null,
          Inventory: row['inventory'] ?? null,
          SubInventory: row['subInventory'] ?? null,
          PriorityCode: row['priorityCode'] ?? null,
          ProductionDate: row['prodDate'] ?? null,
          LineMakeDescription: row['lineMakeDescription'] ?? null,
          EngineeringSeries: row['engineSeries'] ?? null,
          ModelYear: row['modelYear'] ?? null,
          NAModelCodeDescription: row['naModelCodeDesc'] ?? null,
          Region: row['region'] ?? null,
          Market: row['market'] ?? null,
          CenterID: row['centerID'] ?? null,
          LocationCode: row['locationCode'] ?? null,
          DefectCode: row['defectCode'] ?? null,
          DefectDescription: this.commonService.cleanMojibake(
            row['defectDesc'] ?? null
          ),
          BulletinNumber: row['bulletinNber'] ?? null,
          RecallNumber: row['recallNber'] ?? null,
          CampaignType: row['campaignType'] ?? null,
          RemedyStatusAllOpenCampaignsIcon: row?.overallRemedyAvl ?? null,
          RemedyStatusAllOpenCampaignsColor: row?.stopSaleFlg ?? null,
          Color:
            row['stopSaleFlg'] === true ||
            String(row['stopSaleFlg']).trim().toLowerCase() === 'y' ||
            String(row['stopSaleFlg']).trim().toLowerCase() === 'yes' ||
            String(row['stopSaleFlg']).trim().toLowerCase() === 'true'
              ? 'red'
              : '',
        };
      });
      this.exportService.exportCsvWithDetails(
        'ICD_total_Export',
        this.fileDownloadTableData,
        centerCode ? [`Center Code: ${centerCode}`] : [],
        fullCols,
        fullHeaders,
        details,
        { title: '', addBom: true }
      );
    }
  }
  private formatRemedyForCsv(remedyRaw: any): string {
    const list = Array.isArray(remedyRaw)
      ? remedyRaw
      : remedyRaw
        ? [remedyRaw]
        : [];
    return list
      .map((r: any) => {
        const flag = String(r?.defectStopSaleFlag ?? '')
          .trim()
          .toLowerCase();
        const iconText = r?.remedyStatusCode
          ? String(r.remedyStatusCode).trim()
          : '';
        const status = this.commonService.cleanMojibake(
          // ← clean special chars
          String(r?.remedyStatus ?? '').trim()
        );
        return `${iconText}${iconText && status ? ' - ' : ''}${status}`;
      })
      .filter(Boolean)
      .join(' | '); // single-line for CSV
  }

  private hasRedRemedyStatus(remedyRaw: any): boolean {
    const list = Array.isArray(remedyRaw)
      ? remedyRaw
      : remedyRaw
        ? [remedyRaw]
        : [];
    return list.some((r: any) => {
      const flag = String(r?.defectStopSaleFlag ?? r?.defectStopSaleFlg ?? '')
        .trim()
        .toLowerCase();
      return flag === 'y' || flag === 'yes' || flag === 'true' || flag === '1';
    });
  }

  private formatRemedyForPdf(remedyRaw: any): string {
    const list = Array.isArray(remedyRaw)
      ? remedyRaw
      : remedyRaw
        ? [remedyRaw]
        : [];
    return list
      .map((r: any) => {
        const flag = String(r?.defectStopSaleFlag ?? '')
          .trim()
          .toLowerCase();
        const color = flag === 'y' ? 'red' : 'black';
        const iconCode = r?.remedyStatusCode
          ? String(r.remedyStatusCode).trim()
          : '';
        const status = this.commonService.cleanMojibake(
          // ← clean special chars
          String(r?.remedyStatus ?? '').trim()
        );
        return `${color} '@' ${iconCode} - ${status} `;
      })
      .filter(Boolean)
      .join('\n'); // newline => list-like in PDF cell
  }
}
